export default __webpack_public_path__ + "static/cta-pattern-1-064aaa38bb1e96d6dc3bf2b122eb7c30.png";